module.exports = __webpack_public_path__ + "27e64ea1fe3c9085e48cd188c34a36fc.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/foundation.svg
 ** module id = 432
 ** module chunks = 0
 **/